"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7699],{

/***/ 26613:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = exports.Z = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "m20 12-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8z"
}), 'ArrowDownward');

/***/ }),

/***/ 54364:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = exports.Z = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "m4 12 1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8z"
}), 'ArrowUpward');

/***/ }),

/***/ 64938:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


'use client';

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "default", ({
  enumerable: true,
  get: function () {
    return _utils.createSvgIcon;
  }
}));
var _utils = __webpack_require__(23085);

/***/ }),

/***/ 57144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _mui_utils_debounce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86145);

/* harmony default export */ __webpack_exports__["Z"] = (_mui_utils_debounce__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 23085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "capitalize": function() { return /* reexport */ capitalize/* default */.Z; },
  "createChainedFunction": function() { return /* reexport */ utils_createChainedFunction; },
  "createSvgIcon": function() { return /* reexport */ createSvgIcon/* default */.Z; },
  "debounce": function() { return /* reexport */ debounce/* default */.Z; },
  "deprecatedPropType": function() { return /* reexport */ utils_deprecatedPropType; },
  "isMuiElement": function() { return /* reexport */ isMuiElement/* default */.Z; },
  "ownerDocument": function() { return /* reexport */ ownerDocument/* default */.Z; },
  "ownerWindow": function() { return /* reexport */ ownerWindow/* default */.Z; },
  "requirePropFactory": function() { return /* reexport */ utils_requirePropFactory; },
  "setRef": function() { return /* reexport */ utils_setRef; },
  "unstable_ClassNameGenerator": function() { return /* binding */ unstable_ClassNameGenerator; },
  "unstable_useEnhancedEffect": function() { return /* reexport */ useEnhancedEffect/* default */.Z; },
  "unstable_useId": function() { return /* reexport */ useId/* default */.Z; },
  "unsupportedProp": function() { return /* reexport */ utils_unsupportedProp; },
  "useControlled": function() { return /* reexport */ useControlled/* default */.Z; },
  "useEventCallback": function() { return /* reexport */ useEventCallback/* default */.Z; },
  "useForkRef": function() { return /* reexport */ useForkRef/* default */.Z; },
  "useIsFocusVisible": function() { return /* reexport */ useIsFocusVisible/* default */.Z; }
});

// EXTERNAL MODULE: ./node_modules/@mui/utils/ClassNameGenerator/ClassNameGenerator.js
var ClassNameGenerator = __webpack_require__(31983);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/utils/createChainedFunction/createChainedFunction.js
var createChainedFunction = __webpack_require__(15725);
;// CONCATENATED MODULE: ./node_modules/@mui/material/utils/createChainedFunction.js

/* harmony default export */ var utils_createChainedFunction = (createChainedFunction/* default */.Z);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/createSvgIcon.js + 2 modules
var createSvgIcon = __webpack_require__(88169);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/debounce.js
var debounce = __webpack_require__(57144);
;// CONCATENATED MODULE: ./node_modules/@mui/utils/deprecatedPropType/deprecatedPropType.js
function deprecatedPropType(validator, reason) {
  if (true) {
    return () => null;
  }
  return (props, propName, componentName, location, propFullName) => {
    const componentNameSafe = componentName || '<<anonymous>>';
    const propFullNameSafe = propFullName || propName;
    if (typeof props[propName] !== 'undefined') {
      return new Error(`The ${location} \`${propFullNameSafe}\` of ` + `\`${componentNameSafe}\` is deprecated. ${reason}`);
    }
    return null;
  };
}
;// CONCATENATED MODULE: ./node_modules/@mui/material/utils/deprecatedPropType.js

/* harmony default export */ var utils_deprecatedPropType = (deprecatedPropType);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/isMuiElement.js + 1 modules
var isMuiElement = __webpack_require__(56476);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/ownerDocument.js
var ownerDocument = __webpack_require__(8038);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/ownerWindow.js
var ownerWindow = __webpack_require__(5340);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
;// CONCATENATED MODULE: ./node_modules/@mui/utils/requirePropFactory/requirePropFactory.js

function requirePropFactory(componentNameInError, Component) {
  if (true) {
    return () => null;
  }

  // eslint-disable-next-line react/forbid-foreign-prop-types
  const prevPropTypes = Component ? (0,esm_extends/* default */.Z)({}, Component.propTypes) : null;
  const requireProp = requiredProp => (props, propName, componentName, location, propFullName, ...args) => {
    const propFullNameSafe = propFullName || propName;
    const defaultTypeChecker = prevPropTypes == null ? void 0 : prevPropTypes[propFullNameSafe];
    if (defaultTypeChecker) {
      const typeCheckerResult = defaultTypeChecker(props, propName, componentName, location, propFullName, ...args);
      if (typeCheckerResult) {
        return typeCheckerResult;
      }
    }
    if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
      return new Error(`The prop \`${propFullNameSafe}\` of ` + `\`${componentNameInError}\` can only be used together with the \`${requiredProp}\` prop.`);
    }
    return null;
  };
  return requireProp;
}
;// CONCATENATED MODULE: ./node_modules/@mui/material/utils/requirePropFactory.js

/* harmony default export */ var utils_requirePropFactory = (requirePropFactory);
// EXTERNAL MODULE: ./node_modules/@mui/utils/setRef/setRef.js
var setRef = __webpack_require__(25091);
;// CONCATENATED MODULE: ./node_modules/@mui/material/utils/setRef.js

/* harmony default export */ var utils_setRef = (setRef/* default */.Z);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useEnhancedEffect.js
var useEnhancedEffect = __webpack_require__(58974);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useId.js
var useId = __webpack_require__(27909);
;// CONCATENATED MODULE: ./node_modules/@mui/utils/unsupportedProp/unsupportedProp.js
function unsupportedProp(props, propName, componentName, location, propFullName) {
  if (true) {
    return null;
  }
  const propFullNameSafe = propFullName || propName;
  if (typeof props[propName] !== 'undefined') {
    return new Error(`The prop \`${propFullNameSafe}\` is not supported. Please remove it.`);
  }
  return null;
}
;// CONCATENATED MODULE: ./node_modules/@mui/material/utils/unsupportedProp.js

/* harmony default export */ var utils_unsupportedProp = (unsupportedProp);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useControlled.js + 1 modules
var useControlled = __webpack_require__(37388);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useEventCallback.js
var useEventCallback = __webpack_require__(2068);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useForkRef.js
var useForkRef = __webpack_require__(51705);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useIsFocusVisible.js + 1 modules
var useIsFocusVisible = __webpack_require__(39632);
;// CONCATENATED MODULE: ./node_modules/@mui/material/utils/index.js
'use client';



















// TODO: remove this export once ClassNameGenerator is stable
// eslint-disable-next-line @typescript-eslint/naming-convention
const unstable_ClassNameGenerator = {
  configure: generator => {
    if (false) {}
    ClassNameGenerator/* default.configure */.Z.configure(generator);
  }
};

/***/ }),

/***/ 56476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ utils_isMuiElement; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@mui/utils/isMuiElement/isMuiElement.js

function isMuiElement(element, muiNames) {
  var _muiName, _element$type;
  return /*#__PURE__*/react.isValidElement(element) && muiNames.indexOf( // For server components `muiName` is avaialble in element.type._payload.value.muiName
  // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
  // eslint-disable-next-line no-underscore-dangle
  (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}
;// CONCATENATED MODULE: ./node_modules/@mui/material/utils/isMuiElement.js

/* harmony default export */ var utils_isMuiElement = (isMuiElement);

/***/ }),

/***/ 8038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _mui_utils_ownerDocument__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36425);

/* harmony default export */ __webpack_exports__["Z"] = (_mui_utils_ownerDocument__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 5340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _mui_utils_ownerWindow__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96613);

/* harmony default export */ __webpack_exports__["Z"] = (_mui_utils_ownerWindow__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 37388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ utils_useControlled; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@mui/utils/useControlled/useControlled.js
'use client';

/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */

function useControlled({
  controlled,
  default: defaultProp,
  name,
  state = 'value'
}) {
  // isControlled is ignored in the hook dependency lists as it should never change.
  const {
    current: isControlled
  } = react.useRef(controlled !== undefined);
  const [valueState, setValue] = react.useState(defaultProp);
  const value = isControlled ? controlled : valueState;
  if (false) {}
  const setValueIfUncontrolled = react.useCallback(newValue => {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfUncontrolled];
}
;// CONCATENATED MODULE: ./node_modules/@mui/material/utils/useControlled.js
'use client';


/* harmony default export */ var utils_useControlled = (useControlled);

/***/ }),

/***/ 58974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _mui_utils_useEnhancedEffect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54895);
'use client';


/* harmony default export */ __webpack_exports__["Z"] = (_mui_utils_useEnhancedEffect__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 27909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _mui_utils_useId__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89326);
'use client';


/* harmony default export */ __webpack_exports__["Z"] = (_mui_utils_useId__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 15725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ createChainedFunction; }
/* harmony export */ });
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */
function createChainedFunction(...funcs) {
  return funcs.reduce((acc, func) => {
    if (func == null) {
      return acc;
    }
    return function chainedFunction(...args) {
      acc.apply(this, args);
      func.apply(this, args);
    };
  }, () => {});
}

/***/ }),

/***/ 86145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ debounce; }
/* harmony export */ });
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function debounce(func, wait = 166) {
  let timeout;
  function debounced(...args) {
    const later = () => {
      // @ts-ignore
      func.apply(this, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }
  debounced.clear = () => {
    clearTimeout(timeout);
  };
  return debounced;
}

/***/ }),

/***/ 36425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ownerDocument; }
/* harmony export */ });
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

/***/ }),

/***/ 96613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ownerWindow; }
/* harmony export */ });
/* harmony import */ var _ownerDocument__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36425);

function ownerWindow(node) {
  const doc = (0,_ownerDocument__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(node);
  return doc.defaultView || window;
}

/***/ }),

/***/ 89326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useId; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';


let globalId = 0;
function useGlobalId(idOverride) {
  const [defaultId, setDefaultId] = react__WEBPACK_IMPORTED_MODULE_0__.useState(idOverride);
  const id = idOverride || defaultId;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (defaultId == null) {
      // Fallback to this default id when possible.
      // Use the incrementing value for client-side rendering only.
      // We can't use it server-side.
      // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
      globalId += 1;
      setDefaultId(`mui-${globalId}`);
    }
  }, [defaultId]);
  return id;
}

// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const maybeReactUseId = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useId'.toString()];
/**
 *
 * @example <div id={useId()} />
 * @param idOverride
 * @returns {string}
 */
function useId(idOverride) {
  if (maybeReactUseId !== undefined) {
    const reactId = maybeReactUseId();
    return idOverride != null ? idOverride : reactId;
  }
  // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
  return useGlobalId(idOverride);
}

/***/ }),

/***/ 24905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CarouselList": function() { return /* reexport */ CarouselList; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowBackIos.js
var ArrowBackIos = __webpack_require__(20724);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowUpward.js
var ArrowUpward = __webpack_require__(54364);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowDownward.js
var ArrowDownward = __webpack_require__(26613);
// EXTERNAL MODULE: ./src/contexts/CursorContext/Cursor.tsx
var Cursor = __webpack_require__(52746);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
;// CONCATENATED MODULE: ./src/components/CarouselList/@editor/index.ts


var useEditorHandlers = function(name) {
    var theme = (0,useTheme/* default */.Z)();
    return (0,Cursor/* useCursorHandlers */.h)({
        name: name,
        styles: [
            {
                type: "divider"
            },
            {
                type: "header",
                label: "Arrows"
            },
            {
                name: "theme_component_list_arrow_background_color",
                label: "Arrow background color",
                type: "color",
                default: theme.palette.secondary.main
            },
            {
                name: "theme_component_list_arrow_hover_background_color",
                label: "Arrow Hover background color",
                type: "color",
                default: theme.palette.secondary.main
            },
            {
                name: "theme_component_list_arrow_svg_color",
                label: "Arrow icon color",
                type: "color",
                default: theme.palette.common.white
            },
            {
                name: "theme_component_list_arrow_width",
                label: "Arrow width",
                type: "number",
                endAdornment: "px",
                default: 40
            },
            {
                name: "theme_component_list_arrow_min_width",
                label: "Arrow minimum width",
                type: "number",
                endAdornment: "px",
                default: 40
            },
            {
                name: "theme_component_list_arrow_height",
                label: "Arrow height",
                type: "number",
                endAdornment: "px",
                default: 40
            },
            {
                name: "theme_component_list_arrow_minimum_height",
                label: "Arrow height",
                type: "number",
                endAdornment: "px",
                default: 40
            },
            {
                type: "divider"
            },
            {
                type: "header",
                label: "Left arrow"
            },
            {
                name: "theme_component_list_arrow_left_left",
                label: "Left margin",
                type: "number",
                endAdornment: "px",
                default: 0
            },
            {
                name: "theme_component_list_arrow_left_border_radius",
                label: "Border radius",
                type: "text",
                default: "0 ".concat(theme.shape.borderRadius, "px ").concat(theme.shape.borderRadius, "px 0"),
                helperText: "Define as top right left bottom; e.g.: 2px 10px 5px 10px"
            },
            {
                name: "theme_component_list_arrow_left_svg_margin_left",
                label: "Icon left margin",
                type: "number",
                endAdornment: "px",
                default: theme.spacing(1)
            },
            {
                name: "theme_component_list_arrow_left_svg_font_size",
                label: "Icon size",
                type: "number",
                endAdornment: "px",
                default: theme.typography.body1.fontSize
            },
            {
                type: "divider"
            },
            {
                type: "header",
                label: "Right arrow"
            },
            {
                name: "theme_component_list_arrow_right_right",
                label: "Right margin",
                type: "number",
                endAdornment: "px",
                default: 0
            },
            {
                name: "theme_component_list_arrow_right_border_radius",
                label: "Border radius",
                type: "text",
                default: "".concat(theme.shape.borderRadius, "px 0 0 ").concat(theme.shape.borderRadius, "px"),
                helperText: "Define as top right left bottom; e.g.: 2px 10px 5px 10px"
            },
            {
                name: "theme_component_list_arrow_right_svg_margin_right",
                label: "Icon right margin",
                type: "number",
                endAdornment: "px",
                default: theme.spacing(1)
            },
            {
                name: "theme_component_list_arrow_right_svg_font_size",
                label: "Icon size",
                type: "number",
                endAdornment: "px",
                default: theme.typography.body1.fontSize
            }, 
        ],
        configuration: []
    });
};

// EXTERNAL MODULE: ./src/components/Card/index.ts + 10 modules
var Card = __webpack_require__(93091);
// EXTERNAL MODULE: ./src/contexts/AppContext/index.tsx + 5 modules
var AppContext = __webpack_require__(24911);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(92);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(69417);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./src/components/PaperColorElevation/index.ts + 1 modules
var PaperColorElevation = __webpack_require__(80830);
;// CONCATENATED MODULE: ./src/components/CarouselList/styled.tsx



// type arrowOptions = {
//   arrowOptions?: 'default' | 'circular';
// }
var Arrow = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Button/* default */.Z, {
    target: "e1qp3ttq0"
})(function(param) {
    var theme = param.theme;
    return {
        position: "absolute",
        zIndex: 1,
        top: "calc(50% - 30px)",
        width: theme.theme_component_list_arrow_width ? "".concat(theme.theme_component_list_arrow_width, "px") : "40px",
        minWidth: theme.theme_component_list_arrow_min_width ? "".concat(theme.theme_component_list_arrow_min_width, "px") : "40px",
        height: theme.theme_component_list_arrow_height ? "".concat(theme.theme_component_list_arrow_height, "px") : "auto",
        minHeight: theme.theme_component_list_arrow_minimum_height ? "".concat(theme.theme_component_list_arrow_minimum_height, "px") : "auto",
        backgroundColor: theme.theme_component_list_arrow_background_color || theme.palette.secondary.main,
        "& svg": {
            color: theme.theme_component_list_arrow_svg_color || theme.palette.common.white
        },
        hover: {
            backgroundColor: theme.theme_component_list_arrow_hover_background_color
        },
        "&.swiper-button-disabled": {
            filter: "grayscale(1)",
            cursor: "default"
        }
    };
});
var ArrowLeft = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Arrow, {
    target: "e1qp3ttq1"
})(function(param) {
    var theme = param.theme;
    return {
        left: theme.theme_component_list_arrow_left_left ? "".concat(theme.theme_component_list_arrow_left_left, "px") : 0,
        borderRadius: theme.theme_component_list_arrow_left_border_radius || "0 ".concat(theme.shape.borderRadius, "px ").concat(theme.shape.borderRadius, "px 0"),
        "& svg": {
            marginLeft: theme.theme_component_list_arrow_left_svg_margin_left ? "".concat(theme.theme_component_list_arrow_left_svg_margin_left, "px") : theme.spacing(1),
            fontSize: theme.theme_component_list_arrow_left_svg_font_size ? "".concat(theme.theme_component_list_arrow_left_svg_font_size, "px") : undefined
        }
    };
});
var ArrowRight = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Arrow, {
    target: "e1qp3ttq2"
})(function(param) {
    var theme = param.theme;
    return {
        right: theme.theme_component_list_arrow_right_right ? "".concat(theme.theme_component_list_arrow_right_right, "px") : 0,
        borderRadius: theme.theme_component_list_arrow_right_border_radius || "".concat(theme.shape.borderRadius, "px 0 0 ").concat(theme.shape.borderRadius, "px"),
        "& svg": {
            marginRight: theme.theme_component_list_arrow_right_svg_margin_right ? "".concat(theme.theme_component_list_arrow_right_svg_margin_right, "px") : theme.spacing(1),
            fontSize: theme.theme_component_list_arrow_right_svg_font_size ? "".concat(theme.theme_component_list_arrow_right_svg_font_size, "px") : undefined,
            transform: "rotate(180deg)"
        }
    };
});
var ArrowUp = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Arrow, {
    target: "e1qp3ttq3"
})(function(param) {
    var theme = param.theme;
    return {
        top: "12px",
        left: 0,
        right: 0,
        margin: "auto",
        borderRadius: theme.theme_component_list_arrow_left_border_radius || "0 ".concat(theme.shape.borderRadius, "px ").concat(theme.shape.borderRadius, "px 0"),
        "& svg": {
            fontSize: theme.theme_component_list_arrow_left_svg_font_size ? "".concat(theme.theme_component_list_arrow_left_svg_font_size, "px") : undefined
        }
    };
});
var ArrowDown = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Arrow, {
    target: "e1qp3ttq4"
})(function(param) {
    var theme = param.theme;
    return {
        bottom: 0,
        left: 0,
        right: 0,
        margin: "320px auto",
        marginBottom: 0,
        borderRadius: theme.theme_component_list_arrow_right_border_radius || "".concat(theme.shape.borderRadius, "px 0 0 ").concat(theme.shape.borderRadius, "px"),
        "& svg": {
            fontSize: theme.theme_component_list_arrow_right_svg_font_size ? "".concat(theme.theme_component_list_arrow_right_svg_font_size, "px") : undefined
        }
    };
});
var CardSkeletonStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(PaperColorElevation/* PaperColorElevation */.z, {
    target: "e1qp3ttq5"
})(function(param) {
    var theme = param.theme, width = param.width, height = param.height;
    return {
        boxShadow: theme.shadows[0],
        aspectRatio: "".concat(width, "/").concat(height)
    };
});
var CarouselListContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1qp3ttq6"
})(function(param) {
    var vertical = param.vertical;
    return {
        height: vertical ? "inherit" : "100%",
        maxHeight: "100vw",
        minHeight: 0,
        minWidth: 0,
        maxWidth: "100vw",
        width: "100%",
        overflow: "hidden",
        ".swiper > .swiper-wrapper": {
            maxHeight: "100%",
            height: vertical ? "628px" : "100%",
            display: "flex"
        },
        ".swiper > .swiper-slide": {
            width: "auto",
            flexShrink: 0,
            display: "block",
            height: "100%",
            maxHeight: "100%"
        }
    };
});
var TrendSticker = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "e1qp3ttq7"
})("position:absolute;top:24px;background-color:#f9484a;background-image:linear-gradient(315deg,#f9484a 0%,#fbd72b 74%);color:yellow;padding:4px 8px;border-radius:0px 0px 8px 0px;");

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Whatshot.js
var Whatshot = __webpack_require__(87089);
;// CONCATENATED MODULE: ./src/components/CarouselList/CarouselList.tsx



















var defaultBreakpoints = {
    // https://mui.com/customization/breakpoints/
    // Try to keep this similar as CollectionGrid breakpoints.
    1200: {
        // lg
        slidesPerView: 6,
        slidesPerGroup: 6
    },
    900: {
        // md
        slidesPerView: 4,
        slidesPerGroup: 4
    },
    600: {
        // sm
        slidesPerView: 3,
        slidesPerGroup: 3
    },
    0: {
        // xs
        slidesPerView: 2,
        slidesPerGroup: 2
    }
};
var CarouselList = function(props) {
    var items = props.items, className = props.className, children = props.children, padding = props.padding, cardOptions = props.cardOptions, _slidesPerView = props.slidesPerView, slidesPerView = _slidesPerView === void 0 ? 6 : _slidesPerView, _breakpoints = props.breakpoints, breakpoints = _breakpoints === void 0 ? defaultBreakpoints : _breakpoints, _direction = props.// arrowOptions,
    direction, direction = _direction === void 0 ? "horizontal" : _direction, swiperOptions = (0,_object_without_properties/* default */.Z)(props, [
        "items",
        "className",
        "children",
        "padding",
        "cardOptions",
        "slidesPerView",
        "breakpoints",
        "direction"
    ]);
    var theme = (0,useTheme/* default */.Z)();
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var assetUrl = appContext.useConfig().assetUrl;
    var channel = react.useRef(new Date().getTime().toString(36));
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(items || []), 1), slides = ref[0];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CarouselListContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: className
    }, useEditorHandlers("Carousel List")), {
        vertical: direction === "vertical",
        children: [
            children,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(swiper_react/* Swiper */.tq, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                style: {
                    padding: padding
                },
                id: channel === null || channel === void 0 ? void 0 : channel.current,
                modules: [
                    swiper_esm/* Navigation */.W_,
                    swiper_esm/* A11y */.s5,
                    swiper_esm/* Virtual */.eZ
                ],
                loop: (slides === null || slides === void 0 ? void 0 : slides.length) > 1,
                slidesPerView: slidesPerView,
                spaceBetween: parseInt(theme.spacing(2).replace("px ", "")),
                breakpoints: breakpoints,
                a11y: {
                    prevSlideMessage: "Previous slide",
                    nextSlideMessage: "Next slide"
                },
                navigation: {
                    prevEl: ".arrow-left-".concat(channel === null || channel === void 0 ? void 0 : channel.current),
                    nextEl: ".arrow-right-".concat(channel === null || channel === void 0 ? void 0 : channel.current)
                },
                direction: direction || "horizontal"
            }, swiperOptions), {
                children: [
                    slides.map(function(item, index) {
                        /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(swiper_react/* SwiperSlide */.o5, {
                            virtualIndex: index,
                            children: item ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Card */.Zb, (0,_object_spread/* default */.Z)({
                                        sx: {
                                            display: "flex"
                                        },
                                        href: "/game/".concat(item.slug),
                                        src: "".concat(assetUrl).concat((cardOptions === null || cardOptions === void 0 ? void 0 : cardOptions.template) === "big" ? item.images.cover4x1 || item.images.cover16x9 || item.images.cover : item.images.cover16x9 || item.images.cover, "/"),
                                        alt: item.name || "Cover",
                                        title: item.name || undefined,
                                        description: item.description || undefined
                                    }, cardOptions)),
                                    (item === null || item === void 0 ? void 0 : item.trend) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrendSticker, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Whatshot/* default */.Z, {})
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardSkeletonStyled, {
                                elevation: 1,
                                width: cardOptions.width,
                                height: cardOptions.height
                            })
                        }, "".concat(channel === null || channel === void 0 ? void 0 : channel.current).concat(index));
                    }),
                    direction === "horizontal" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowLeft, {
                                variant: "contained",
                                "aria-label": "Previous",
                                color: "secondary",
                                // arrowOptions={arrowOptions}
                                className: "arrow-left-".concat(channel.current),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowBackIos/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowRight, {
                                variant: "contained",
                                "aria-label": "Next",
                                color: "secondary",
                                // arrowOptions={arrowOptions}
                                className: "arrow-right-".concat(channel.current),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowBackIos/* default */.Z, {})
                            })
                        ]
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowUp, {
                                variant: "contained",
                                "aria-label": "Previous",
                                color: "secondary",
                                // arrowOptions={arrowOptions}
                                className: "arrow-left-".concat(channel.current),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowUpward/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowDown, {
                                variant: "contained",
                                "aria-label": "Next",
                                color: "secondary",
                                // arrowOptions={arrowOptions}
                                className: "arrow-right-".concat(channel.current),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowDownward/* default */.Z, {})
                            })
                        ]
                    })
                ]
            }))
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/CarouselList/index.ts



/***/ })

}]);